/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ChartBarIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <rect x="0.5" y="3.5" width="23" height="17" />
      <rect x="2.5" y="5.5" width="19" height="13" />
      <path d="M5.5,16.5 L5.5,14.5" />
      <path d="M7.5,16.5 L7.5,11.5" />
      <path d="M9.5,16.5 L9.5,13.5" />
      <path d="M11.5,16.5 L11.5,14.5" />
      <path d="M17.5,16.5 L17.5,9.5" />
      <path d="M15.5,16.5 L15.5,12" />
      <path d="M13.5,16.5 L13.5,7.5" />
    </g>
  </svg>
);

export default ChartBarIcon;
